import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconTensorflowLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M13.3693 5.07678V8.15384L19.0538 11.2309V8.15384L13.3693 5.07678ZM2 8.15384V11.2309L4.84225 12.7691V9.69237L2 8.15384ZM10.5268 9.69237L7.68449 11.2309V20.4615L10.5268 22V15.8462L13.3693 17.3847V14.3077L10.5268 12.7691V9.69237Z",
			fill: "#E55B2D"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.3693 5.07678L4.84219 9.69237V12.7691L10.5267 9.69237V12.7691L13.3693 11.2309V5.07678ZM21.8963 6.61531L19.0537 8.15384V11.2309L21.8963 9.69237V6.61531ZM16.2115 12.7691L13.3693 14.3077V17.3847L16.2115 15.8462V12.7691ZM13.3693 17.3847L10.5267 15.8462V22L13.3693 20.4615V17.3847Z",
			fill: "#ED8E24"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.3693 2L2 8.1538L4.84225 9.69233L13.3693 5.07675L19.0538 8.1538L21.8964 6.61527L13.3693 2ZM13.3693 11.2309L10.5268 12.7691L13.3693 14.3076L16.2116 12.7691L13.3693 11.2309Z",
			fill: "#F8BF3C"
		})
	]
});
export { SvgIconTensorflowLogo as ReactComponent };
